<div class="rd-specs repair-diagram-content flex-row" *ngIf="fluids.length  || this.specifications.length">
  <!-- Dialog Left Side Content -->
  <div class="repair-diagram-content-left">
    <!-- List of Fluid & Specification -->
    <div class="repair-diagram-list flex-column">
      <!-- Fluid heading -->
      <div class="repair-diagram-list-item flex-start-center pointer" *ngIf="fluids?.length">
        <p class="mb-0 flex-column">
          <span class="font-bold capitalize">FLUIDS</span>
        </p>
      </div>

      <!-- Fluid list -->
      <div class="repair-diagram-list-item flex-start-center pointer" *ngFor="let fluid of fluids"
        [ngClass]="{'active': fluid?.applicationId === selectedFluid?.applicationId}"
        (click)="selectedFluid = fluid; getSpecDetails(fluid.applicationId, 'fluid')">
        <p class="mb-0 flex-column">
          <span class="capitalize">{{fluid?.displayName}}</span>
          <span>{{fluid?.description}}</span>
        </p>
      </div>

      <!-- Specs heading -->
      <div class="repair-diagram-list-item flex-start-center pointer" *ngIf="specifications?.length">
        <p class="mb-0 flex-column">
          <span class="font-bold capitalize">Specifications</span>
        </p>
      </div>

      <!-- Specs list -->
      <div class="repair-diagram-list-item flex-between-center pointer" *ngFor="let specification of specifications"
        [ngClass]="{'active': specification?.applicationId === selectedFluid?.applicationId}"
        (click)="selectedFluid = specification;getSpecDetails(specification.applicationId, 'spec')">
        <p class="mb-0">
          <span class="capitalize">{{specification?.displayName}}</span>
        </p>
      </div>
    </div>
  </div>

  <!-- Dialog Right Side Content -->
  <div class="repair-diagram-content-right p-2 repair-diagram-wrapper" [hidden]="isLoading">
    <p class="mb-1 text-center font-16 font-600">{{selectedSpecs?.liternalName}}</p>
    <p class="mb-1">{{selectedSpecs?.description}}</p>

    <table class="width-100p">
      <thead>
        <th class="font-600 min-width-125 pr-1 pl-1" *ngFor="let header of headers">{{header?.name}}</th>
      </thead>

      <tbody>
        <tr *ngFor="let item of selectedSpecs?.items">
          <td *ngFor="let header of headers" class="pr-1 pl-1">
            <span *ngIf="header?.value === 'grade'" class="font-motor" tooltipPosition="top"
              [pTooltip]="item?.grade?.description">
              {{item?.grade?.name}}
            </span>

            <span *ngIf="!['grade'].includes(header?.value)">
              {{item[header?.value]}}
            </span>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="image-viewer-counter-wrapper" *ngIf="documentUrls?.length > 1">
      <span class="font-18 font-gray-45 font-600">{{imageIndex + 1}} of {{documentUrls?.length}}</span>
    </div>

    <angular-image-viewer *ngIf="documentUrls?.length" [src]="documentUrls" [(index)]="imageIndex" [config]="config">
    </angular-image-viewer>
  </div>

  <!-- <div class="repair-diagram-content-right p-2 repair-diagram-wrapper" [hidden]="isLoading">

  </div> -->

  <div class="repair-diagram-content-right p-2" [hidden]="!isLoading">
    <div class="flex-start-center font-14">
      <span class="pr-2">Loading...</span>
      <i class="fal fa-spinner rotate"></i>
    </div>
  </div>
</div>

<div class="rd-specs repair-diagram-content" *ngIf="!fluids.length  && !this.specifications.length">
  <div class="flex-center-center specs-service flex-column">
    <img src="../../../../../../assets/img/empty-icon-diagrams.svg" alt="" />
    <div class="pr-2 font-12 pt-2 font-gray-35">There are no specs associated with this service.
    </div>
  </div>
</div>
